import React, { Component } from 'react';

export class AtchList extends Component {
  state = { atchList: []}

  printSize(size) {
		var sizes = "kMGT" //PEZY";

		for(let i=sizes.length-1;i>=0;i--) {
			if(size >= Math.pow(1024, i+1)) return (size/Math.pow(1024, i+1)).toFixed(2) + " " + sizes[i] + "B";
		}

		return size + " B";
  }

  componentWillReceiveProps(p) {
    this.setState({
      atchList: ((p.detail || {}).prilohy || {}).data || []
    })
  }
  
  async update(id) {
    const json = await window.fetchj("/prilohy/"+id);
    this.setState({ atchList: json.data||[] })
  }

  render() {
    const url = window.location.hostname == "localhost" ? "http://localhost:8080" : "";

    const atch = this.state.atchList.map(m => 
      <a className="priloha" 
        href={`${url}/prilohy/detail/${m.attGuid}/${m.attNameExt}`}
        onClick={e=> (e.preventDefault(), this.props.preview(`${url}/prilohy/detail/${m.attGuid}/${m.attNameExt}`))} 
        title={this.printSize(m.attSize)}>{m.attNameExt}
      </a>
    )

    return <div id="seznamPriloh" className={atch.length ? "" : "empty"}>{atch}</div>
  }
}